import { SxProps, Theme } from '@mui/material';
import { Row } from '@tanstack/react-table';
import { format } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { i18n } from 'i18next';
import { EmployeeBenefitSettingsShort } from '@pxtra-client-lib-legacy/gen';

export const DEFAULT_PAGE_SIZE = 25;

export const BENEFIT_KEYS: (keyof EmployeeBenefitSettingsShort)[] = [
  'sachbezug',
  'essenszuschuss',
  'öpnv_tickets',
  'fahrtkosten',
  'erholungsbeihilfe',
  'betreuungskosten',
  'internetpauschale',
  'telefonkosten',
  'jobbike',
  'mpp',
  'bkv',
  'bav'
];

export const getNextMonthHeaderSuffix = (i18n: i18n): string =>
  ` (${format(new Date().setMonth(new Date().getMonth() + 1), 'MMM', {
    locale: i18n.language === 'de' ? de : enUS
  })})`;

export const scrollableTableContainerSx = (maxHeight?: string): SxProps<Theme> => ({
  overflow: 'auto',
  overflowY: 'auto',
  flex: 1,
  minHeight: 0,
  ...(maxHeight && { maxHeight }),
  '& .MuiTableHead-root': {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: 'white'
  },
  '&::-webkit-scrollbar': {
    width: '6px',
    maxHeight: '6px'
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '8px'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'grey.400',
    borderRadius: '8px',
    border: 'none'
  }
});

type RowWithId = {
  id?: string;
};

type GetRowClassNameOptions<T extends RowWithId> = {
  row: Row<T>;
  missingDataIds?: Set<string | undefined>;
  selectedClass?: string;
  selectedHoverClass?: string;
  defaultHoverClass?: string;
  missingDataClass?: string;
};

export const getRowStyling = <T extends RowWithId>({
  row,
  missingDataIds,
  selectedClass = 'bg-heaven-200',
  selectedHoverClass = 'hover:bg-heaven-300',
  defaultHoverClass = 'hover:bg-heaven-100',
  missingDataClass = 'bg-warning-lightest'
}: GetRowClassNameOptions<T>): string => {
  if (missingDataIds?.has(row.original.id)) {
    return missingDataClass;
  }
  if (row.getIsSelected()) {
    return `${selectedClass} ${selectedHoverClass}`;
  }
  return defaultHoverClass;
};
